<template>
  <div class="my-account">
    <div class="wrapper">
      <div class="header">
        <div class="headerCon">
          <div class="account acea-row row-top row-between">
            <div class="assets">
              <div>总资产(点/券)</div>
              <div class="money">
                {{ now_money }}
                <span :style="{ 'font-size': '0.3rem' }">{{ pastdue }}</span>
              </div>
              <div class="time">{{ addTime }}-{{ endTime }}</div>
              <div class="timeyx">点券状态： {{ youxiao }}</div>
            </div>
            <router-link :to="{path: '/user/Recharge', query: { id: $route.query.id }}" class="recharge font-color-red"
              >充值</router-link
            >
          </div>
          <div class="cumulative acea-row row-top">
            <div class="item">
              <div>累计充值(点/券)</div>
              <div class="money">{{ recharge }}</div>
            </div>
            <div class="item">
              <div>累计消费(点/券)</div>
              <div class="money">{{ orderStatusSum }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="nav acea-row row-middle" v-if="false">
        <router-link class="item" :to="'/user/bill/0'">
          <div class="pictrue"><img src="@assets/images/record1.png" /></div>
          <div>账单记录</div>
        </router-link>
        <router-link class="item" :to="'/user/bill/1'">
          <div class="pictrue"><img src="@assets/images/record2.png" /></div>
          <div>消费记录</div>
        </router-link>
        <router-link class="item" :to="'/user/bill/2'">
          <div class="pictrue"><img src="@assets/images/record3.png" /></div>
          <div>充值记录</div>
        </router-link>
        <!--<router-link class="item" :to="'/user/integral'">
          <div class="pictrue"><img src="@assets/images/record4.png" /></div>
          <div>积分中心</div>
        </router-link>-->
      </div>
      <div class="advert acea-row row-between-wrapper" v-if="false">
        <router-link
          class="item acea-row row-between-wrapper"
          :to="'/user/sign'"
        >
          <div class="text">
            <div class="name">签到领积分</div>
            <div>赚积分抵现金</div>
          </div>
          <div class="pictrue"><img src="@assets/images/gift.png" /></div>
        </router-link>
        <router-link
          class="item on acea-row row-between-wrapper"
          :to="'/user/get_coupon'"
        >
          <div class="text">
            <div class="name">领取优惠券</div>
            <div>满减享优惠</div>
          </div>
          <div class="pictrue"><img src="@assets/images/money.png" /></div>
        </router-link>
      </div>
      <div class="list" v-if="false">
        <div class="item acea-row row-between-wrapper">
          <div class="picTxt acea-row row-between-wrapper">
            <div class="iconfont icon-hebingxingzhuang"></div>
            <div class="text">
              <div class="line1">最新拼团活动</div>
              <div class="infor line1">最新的优惠商品上架拼团</div>
            </div>
          </div>
          <router-link
            class="bnt"
            :to="'/activity/group'"
            v-if="activity.is_pink"
            >立即参与</router-link
          >
          <div class="bnt end" v-else>已结束</div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div class="picTxt acea-row row-between-wrapper">
            <div class="iconfont icon-miaosha yellow"></div>
            <div class="text">
              <div class="line1">当前限时秒杀</div>
              <div class="infor line1">最新商品秒杀进行中</div>
            </div>
          </div>
          <router-link
            class="bnt"
            :to="'/activity/goods_seckill'"
            v-if="activity.is_seckill"
            >立即参与</router-link
          >
          <div class="bnt end" v-else>已结束</div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div class="picTxt acea-row row-between-wrapper">
            <div class="iconfont icon-kanjia1 green"></div>
            <div class="text">
              <div class="line1">砍价活动</div>
              <div class="infor line1">呼朋唤友来砍价</div>
            </div>
          </div>
          <router-link
            class="bnt"
            :to="'/activity/bargain'"
            v-if="activity.is_bargin"
            >立即参与</router-link
          >
          <div class="bnt end" v-else>已结束</div>
        </div>
      </div>
    </div>
    <!-- <Recommend></Recommend> -->
  </div>
</template>

<script>
import Recommend from "@components/Recommend";
import { getActivityStatus, getBalance, getCouponsUser } from "../../api/user";
export default {
  name: "UserAccount",
  components: {
    // Recommend
  },
  props: {},
  data: function() {
    return {
      now_money: 0,
      youxiao:"正常",
      orderStatusSum: 0,
      recharge: 0,
      activity: {
        is_bargin: false,
        is_pink: false,
        is_seckill: false
      },
      couponsList: [],

      timePrice: "",
      pastdue: "",
      endTime: "",
      addTime: ""
    };
  },
  mounted: function() {
    this.getIndex();
    this.getActivity();
    // 老版判断有效期
    // function formatDate(now) {
    //   var year = now.getFullYear();
    //   var month = now.getMonth() + 1;
    //   var date = now.getDate();
    //   return year + "/" + month + "/" + date;
    // }
    // this.timePrice = formatDate(new Date());
    // getCouponsUser(0).then(res => {
    //   this.couponsList = res.data;
    //   this.endTime = this.couponsList[0].end_time;
    //   this.addTime = this.couponsList[0]._add_time;
    //   console.log(this.endTime);
    //   if (this.endTime > this.timePrice) {
    //     //console.log("已经过了使用期限")
    //     //alert('已经过了使用期限')
    //     this.pastdue = "已失效";
    //   }
    // });
  },
  methods: {
    getIndex: function() {
      let that = this;
      let number = this.$route.query.id;
      getBalance(number).then(
        res => {
          that.now_money = res.data.now_money;
          that.orderStatusSum = res.data.orderStatusSum;
          that.recharge = res.data.recharge;
          this.endTime = res.data._end_time;
          this.addTime = res.data._add_time;
          this.youxiao = res.data._msg
        },
        err => {
          that.$dialog.message(err.msg);
        }
      );
    },
    getActivity: function() {
      let that = this;
      getActivityStatus().then(
        res => {
          that.activity.is_bargin = res.data.is_bargin;
          that.activity.is_pink = res.data.is_pink;
          that.activity.is_seckill = res.data.is_seckill;
        },
        error => {
          that.$dialog.message(error.msg);
        }
      );
    }
  }
};
</script>
